import { TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
/**========================================================================
 * *         name =string =>   input name
 *           label=string =>  input label
 *           deActive=boolean  => form deActive input
 *           formValues=any  =>input value
 *           formik =boolean   =>call inpt in formik form
 *
 *
 *========================================================================**/
function DatePic({
  lable,
  setFormValues,
  name,
  formValues,
  deActive,
  formik,
  disabled,
  width = "96%",
  onlyYear = false,   // ✅ جدید
  ...rest
}) {
  const handleChange = (newValue) => {
    if (deActive) return;

    const gregorian = onlyYear
      ? newValue.clone().locale("en").format("YYYY")
      : newValue.clone().locale("en").format("YYYY-MM-DD");

    if (!formik) {
      setFormValues((prev) => ({ ...prev, [name]: gregorian }));
    } else {
      setFormValues(name, gregorian);
    }
  };

  return (
    <DesktopDatePicker
      {...rest}
      label={lable}
      disableMaskedInput
      inputFormat={onlyYear ? "jYYYY" : "jYYYY-jMM-jDD"}   // ✅ جدید
      views={onlyYear ? ["year"] : ["year", "month", "day"]} // ✅ جدید
      openTo={onlyYear ? "year" : "day"}                  // ✅ جدید
      value={formValues[name] ? formValues[name] : null}
      onChange={handleChange}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          fullWidth
          sx={{
            "& .MuiInputBase-input": { padding: "8px", margin: "0 8px" },
            "& .MuiOutlinedInput-root": {
              margin: "0 8px !important",
              width: `${width} !important`,
            },
          }}
          value={formValues?.[name] || ""}
          {...params}
        />
      )}
    />
  );
}

export default DatePic;
